import Vue from "vue"
import vuetify from "../plugins/vuetify"
import store from "../store"

export default {
    data(){
        return {
            showHJPDialog : false,
            // putting all of them here in case if some day in future we change the key values in db then we could change value only here instead of updating it everywhere
            hj_plus_popup_feature_keys: {
                'launch_website' : 'launch_website',
                'start_marketing' : 'start_marketing',
                'create_team' : 'create_team',
                'invite_team' : 'invite_team',
                'onboarding' : 'onboarding'
            },
        }
    },

    computed: {
        houseJetMembership(){
            return this.$store.getters['current_user/getHouseJetMembership']
        },
        hasHJPBillingProfile(){
            return !!this.houseJetMembership.billing_profile_id
        }
    },
    methods : {
        async isHouseJetPlusActive(){
            return this.houseJetMembership.is_active
        },
        async checkIfHJPopupAllowedForThisKey(key_type){
            let key_to_check = this.hj_plus_popup_feature_keys?.[key_type];
            if(!key_to_check) return false;
            let { data : { allowed } } = await this.$http.get(`/api/v1/onboarding/is-plus-popup-allowed-for-key/${key_to_check}`)
            return allowed
        },
        /**
         * @param options
         */
        async showHouseJetPlusDialog(options, freePlusDialog = false){
            console.log('showHJPDialog', this.showHJPDialog)
            if ( this.showHJPDialog ) return      // dialog is already showing
            if ( options?.key_type ){
                let isAllowed = await this.checkIfHJPopupAllowedForThisKey(options?.key_type)
                if(!isAllowed) return;
            }

            if ( !this.hasHJPBillingProfile ){
                this.showHJPBillingProfileDialog(options)
                return
            }

            // Lazy load PlusDialog to avoid circular import issues
            const PlusDialog = freePlusDialog ? (await import("../components/HouseJet/FreePlusDialog.vue")).default : (await import("../components/HouseJet/PlusDialog.vue")).default

            this.showHJPDialog = true
            var ComponentClass = Vue.extend(PlusDialog)
            var instance = new ComponentClass({
                vuetify,
                store,
                propsData: {
                    "value" : this.showHJPDialog,
                    "type": (options?.type ?? 'default')
                }
            })
            instance.$on('input', (v) => { this.showHJPDialog = v })
            if ( options?.membershipActivatedCallback ){
                instance.$on('membership-activated', options.membershipActivatedCallback)
            }
            if ( options?.membershipRejectedCallback ){
                instance.$on('rejected', options.membershipRejectedCallback)
            }
            instance.$mount() // pass nothing
            const container = document.querySelector('[data-app=true]') || document.body
            container.appendChild(instance.$el)
        },

        async showHJPBillingProfileDialog(options){
            // Lazy load PlusDialog to avoid circular import issues
            const Dialog = (await import("../components/HouseJet/HJPBillingProfileDialog.vue")).default

            this.showHJPDialog = true
            options.value = this.showHJPDialog    // set dialog to visible
            var ComponentClass = Vue.extend(Dialog)
            var instance = new ComponentClass({
                vuetify,
                store,
                propsData: options
            })
            instance.$on('input', (v) => { this.showHJPDialog = v })
            if ( options?.membershipActivatedCallback ){
                instance.$on('membership-activated', options.membershipActivatedCallback)
            }
            if ( options?.membershipRejectedCallback ){
                instance.$on('rejected', options.membershipRejectedCallback)
            }

            instance.$mount() // pass nothing
            const container = document.querySelector('[data-app=true]') || document.body
            container.appendChild(instance.$el)
        }
    }
}